import {
  HeartPulse,
  Hotel,
  Sparkles,
  Store,
  UtensilsCrossed,
  type LucideIcon,
} from "lucide-react";

import type { IndustryId } from "./navigation";

const INDUSTRY_ICONS: Record<IndustryId, LucideIcon> = {
  restaurants: UtensilsCrossed,
  "salons-spas": Sparkles,
  hotels: Hotel,
  healthcare: HeartPulse,
  retail: Store,
};

export function IndustryIcon({
  id,
  className = "industry-icon",
}: {
  id: IndustryId;
  className?: string | undefined;
}) {
  const Icon = INDUSTRY_ICONS[id];

  return (
    <Icon
      className={className}
      width={28}
      height={28}
      strokeWidth={1.65}
      absoluteStrokeWidth
      aria-hidden="true"
      focusable="false"
      data-industry-icon={id}
    />
  );
}
